import { useContext, useEffect, useRef, useState } from 'react'
import PageWrapper from '../../layout/PageWrapper/PageWrapper'
import Page from '../../layout/Page/Page'
import Card, { CardActions, CardBody, CardHeader, CardLabel, CardTitle } from '../bootstrap/Card'
import Input from '../bootstrap/forms/Input'
import Button from '../bootstrap/Button'
import AuthContext from '../../contexts/authContext'
import { toasts } from '../../services/toaste.service'
import { getDispatchListByDate, updatePackingDetails } from '../../services/productService'
import FormGroup from '../bootstrap/forms/FormGroup'
import Collapse from '../bootstrap/Collapse'
import { convertDateToEpoch, getCompanyDetails, getCurrentDateAndTime, onlyAllowNumber } from '../../services/common.service'
import OpenCardComponent from '../../common/components/OpenCardComponent'
import useSortableData from '../../hooks/useSortableData'
import { dataPagination } from '../PaginationButtons'
import { useReactToPrint } from 'react-to-print';
import SearchableSelect from '../../common/components/SearchableSelect'
import { getLicenseKey } from '../../services/application.settings'
import { showLoader } from '../../services/loader.services'
import dayjs from 'dayjs'
import Icon from '../icon/Icon'

const DispatchList = () => {

    useEffect(() => {
        getCompanyList();
    }, [])

    // For Alert
    const [alertStatus, setAlertStatus] = useState<any>({ message: "", type: "" });
    const [isOpen, setIsOpen] = useState(false);

    const { userAccountId, userTypeId } = useContext(AuthContext);
    const [productList, setProductList] = useState<any>([])
    const [noDataMsg, setNoDataMsg] = useState('');
    const [date, setDate] = useState<any>(getCurrentDateAndTime('date'));

    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const { items, requestSort, getClassNamesFor } = useSortableData(productList);
    const onCurrentPageData = dataPagination(items, currentPage, perPage);

    const [dataStatus, setDataStatus] = useState(false)
    const [isOpenListCard, setIsOpenListCard] = useState(true);
    const [isLoader, setIsLoader] = useState(false);

    function viewProductList() {
        setDataStatus(false)
        let dateInMilliSeconds = convertDateToEpoch(date);
        if (companyDetailsId?.value != undefined) {
            getScannedProductList(dateInMilliSeconds, companyDetailsId?.value)
        }

    }

    function getScannedProductList(date: any, companyDetailsId: any) {
        setDataStatus(false)
        setIsLoader(true)
        getDispatchListByDate(date, companyDetailsId,
            (response) => {
                if (response.data.success) {
                    let rawData = response.data.data.dispatchListByDate;
                    if (rawData != undefined) {
                        const flattenedData: any[] = [];

                        for (let i = 0; i < rawData.length; i++) {
                            const dispatch = rawData[i];
                            if (dispatch.lotDetails) {
                                for (let j = 0; j < dispatch.lotDetails.length; j++) {
                                    const lot = dispatch.lotDetails[j];

                                    const flatItem: any = {
                                        ...dispatch,
                                        ...lot,
                                        productList: lot.dispatchItems || [],
                                        truckNo: dispatch.vehicleNo,
                                        updatedDateForView: dispatch.dispatchDate,
                                    };

                                    // Calculate totals
                                    flatItem.totalGrossWeight = flatItem.productList.reduce((s: any, r: any) => s + Number(r.grossWeight || 0), 0);
                                    flatItem.totalTareWeight = flatItem.productList.reduce((s: any, r: any) => s + Number(r.tareWeight || 0), 0);
                                    flatItem.totalNetWeight = flatItem.productList.reduce((s: any, r: any) => s + Number(r.netWeight || 0), 0);

                                    // Packing List logic
                                    if (dispatch.packingDetails != null) {
                                        flatItem['packingList'] = dispatch.packingDetails;
                                        const validPacking = dispatch.packingDetails.filter((p: any) => p.packingDescription && p.packingDate && p.packingCount);
                                        const totalPackingCount = validPacking.reduce((s: any, r: any) => s + Number(r.packingCount || 0), 0);
                                        flatItem['totalPackingCount'] = (validPacking.length > 0 ? (totalPackingCount / validPacking.length) : 0).toFixed(2)
                                    } else {
                                        flatItem['packingList'] = [
                                            { packingDetailsId: 0, dispatchProductDetailsId: flatItem.dispatchProductDetailsId || 0, packingDescription: '', packingDate: getCurrentDateAndTime('date'), packingCount: '', displayOrder: 1 }
                                        ]
                                    }

                                    // Sn.No for productList
                                    for (let k = 0; k < flatItem.productList.length; k++) {
                                        flatItem.productList[k].sno = k + 1;
                                    }

                                    // Padding for printing
                                    const rowsPerTable = Math.ceil(flatItem.productList.length / 2);
                                    const totalRequired = rowsPerTable * 2;
                                    let paddedRows: any = [...flatItem.productList];

                                    while (paddedRows.length < totalRequired) {
                                        paddedRows.push({ sno: '', bagNo: "", exciseNo: "", grossWeight: "", tareWeight: "", netWeight: "" });
                                    }

                                    const left = paddedRows.slice(0, rowsPerTable);
                                    const right = paddedRows.slice(rowsPerTable);

                                    flatItem.leftRows = left;
                                    flatItem.rightRows = right;

                                    const totals = (rows: any) =>
                                        rows.reduce((a: any, r: any) => ({
                                            gross: a.gross + Number(r.grossWeight || 0),
                                            tare: a.tare + Number(r.tareWeight || 0),
                                            net: a.net + Number(r.netWeight || 0),
                                        }), { gross: 0, tare: 0, net: 0 });

                                    flatItem.leftTotals = totals(left);
                                    flatItem.rightTotals = totals(right);

                                    flattenedData.push(flatItem);
                                }
                            }
                        }

                        setDataStatus(true)
                        setIsOpenListCard(false);
                        setIsLoader(false)
                        setProductList(flattenedData)

                        let packingData = flattenedData.flatMap((item: any) => item.packingList)
                        let packingList = packingData.filter((item: any) => item.packingDescription !== '' || item.packingDate !== '' || item.packingCount !== '')
                        setPackingList(packingList);
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setNoDataMsg(response.data.message)
                    setDataStatus(true)
                    setIsOpenListCard(false);
                    setIsLoader(false)
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                    setIsLoader(false)
                }
            }, error => {
                toasts(error, "Error")
                setIsLoader(false)
            }
        )
    }

    const [isPrintShow, setIsPrintShow] = useState<any>(true);

    const componentRef = useRef(null);

    const handlePrint = useReactToPrint({
        contentRef: componentRef,
    });

    const [refreshData, setRefreshData] = useState<any>([]);

    const [addExamHallAllocation, setAddExamHallAllocation] = useState<any>([
        { packingDescription: '', packingDate: getCurrentDateAndTime('date'), packingCount: '', displayOrder: 1 }
    ])

    function add(data: any) {

        const newData: any = []

        productList.forEach((item: any) => {
            if (item['dispatchProductDetailsId'] == data['dispatchProductDetailsId']) {
                item['packingList'] = [...item['packingList'], { dispatchProductDetailsId: item['dispatchProductDetailsId'], packingDescription: '', packingDate: getCurrentDateAndTime('date'), packingCount: '', displayOrder: item['packingList'].length + 1 }]
            }
            newData.push(item)
        });

        setProductList(newData);
        setRefreshData(newData)

    }

    const [packingList, setPackingList] = useState<any>([])

    function onValueChange(productData: any, value1: any, date1: any, count1: any, index: any) {

        const newData: any = []

        productList.forEach((item: any) => {

            if (item['dispatchProductDetailsId'] == productData['dispatchProductDetailsId']) {

                const list = [...item['packingList']];
                list[index]["packingDetailsId"] = productData['packingDetailsId'] != undefined ? productData['packingDetailsId'] : 0;
                list[index]["dispatchProductDetailsId"] = productData['dispatchProductDetailsId'];
                list[index]["packingDescription"] = value1;
                list[index]["packingDate"] = date1;
                list[index]["packingCount"] = count1;
                list[index]["displayOrder"] = index + 1;

                const validPacking = list.filter((p: any) => p.packingDescription && p.packingDate && p.packingCount);
                const totalPackingCount = validPacking.reduce((s: any, r: any) => s + Number(r.packingCount || 0), 0);

                item['packingList'] = list
                item['totalPackingCount'] = (validPacking.length > 0 ? (totalPackingCount / validPacking.length) : 0).toFixed(2)

                setAddExamHallAllocation(list)
                setRefreshData(list)
            }
            newData.push(item)
        });

        let packingData = newData.flatMap((item: any) => item.packingList)
        let packingList = packingData.filter((item: any) => item.packingDescription !== '' || item.packingDate !== '' || item.packingCount !== '')
        setPackingList(packingList)
    }

    function selectPrint() {
        handlePrint();
        setIsPrintShow(true)
    }

    const [companyDetailsData, setCompanyDetailsData] = useState<any>([]);
    const [companyDetailsId, setCompanyDetailsId] = useState<any>('');

    function getCompanyList() {
        getCompanyDetails(0,
            (response) => {
                if (response.data.success) {
                    let data = response.data.data.companyDetails;
                    if (data != undefined) {
                        setCompanyDetailsData(data)
                    } else {
                        toasts("Undefined Data", "Error")
                    }
                }
                else if (response.data.success === false) {
                    setCompanyDetailsData([])
                } else {
                    let errorCode = response.data.error[0].error_code;
                    let errorDescription = response.data.error[0].error_description;
                    toasts(errorDescription, "Error")
                }
            }, error => {
                toasts(error, "Error")
            }
        )
    }

    function setPackingDetails() {
        return ({
            licenseKey: getLicenseKey,
            userAccountId: userAccountId,
            packingDetails: packingList
        })
    }

    function updatePackingDetailsSubmit() {
        let challanPostData = setPackingDetails()
        if (packingList?.length > 0) {
            updatePackingDetails(challanPostData,
                (response) => {
                    const data = response.data;
                    if (data.success == true) {
                        showLoader(false)
                        setAlertStatus({ message: data.message, type: "success" });
                        setIsOpen(true);
                        selectPrint()
                        closeAndReset()
                    }
                    else if (data.success == false) {
                        showLoader(false)
                        selectPrint()
                        setAlertStatus({ message: data.message, type: "error" });
                        setIsOpen(true);
                    }
                    else {
                        let errorCode = response.data.error[0].error_code;
                        let errorDescription = response.data.error[0].error_description;
                        showLoader(false)
                        selectPrint()
                        setAlertStatus({ message: errorDescription, type: "error" });
                        setIsOpen(true);
                    }
                }, (error) => {
                    showLoader(false)
                    selectPrint()
                    setAlertStatus({ message: error, type: "error" });
                    setIsOpen(true);
                }
            )
        }
        else {
            selectPrint()
            showLoader(false)
            // toasts("Please Enter Dispatch Details", "Error");
        }
    }

    function closeAndReset() {
        setPackingList([])
        let dateInMilliSeconds = convertDateToEpoch(date);
        if (companyDetailsId?.value != undefined) {
            getScannedProductList(dateInMilliSeconds, companyDetailsId?.value)
        }
    }

    return (
        <PageWrapper title={`Weight List`}>
            <Page>
                <Collapse isOpen={isOpenListCard}>
                    <Card stretch data-tour='list' className='d-print-none'>
                        <CardHeader borderSize={1}>
                            <CardLabel icon='List' iconColor='info'>
                                <CardTitle>Weight List</CardTitle>
                            </CardLabel>
                        </CardHeader>
                        <CardBody>
                            <div className='row g-4'>
                                <div className='col-lg-3'>
                                    <FormGroup
                                        id='date'
                                        label='Date'
                                        isFloating>
                                        <Input
                                            type='date'
                                            placeholder='Date'
                                            onChange={(e: any) => setDate(e.target.value)}
                                            value={date}
                                            max={getCurrentDateAndTime('date')}
                                        />
                                    </FormGroup>
                                </div>
                                <div className='col-lg-5'>
                                    <FormGroup id='placeOfSupply' label='Select Company' isFloating>
                                        <SearchableSelect
                                            isFloating
                                            ariaLabel='placeOfSupply'
                                            onChange={(e: any) => { setCompanyDetailsId(e); setDataStatus(false); setProductList([]); setPackingList([]); }}
                                            value={companyDetailsId}
                                            list={companyDetailsData.map((data: any) => ({
                                                value: data.companyDetailsId,
                                                label: data.companyNameAndCityName,
                                            }))}
                                            required
                                        />
                                    </FormGroup>
                                </div>
                                <div className='col-lg-3'>
                                    <Button
                                        color={'primary'}
                                        className='mt-2'
                                        icon='ArrowDownward'
                                        onClick={() => {
                                            setIsPrintShow(false);
                                            viewProductList();
                                        }}>
                                        View
                                    </Button>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Collapse>

                <OpenCardComponent isOpenListCard={isOpenListCard} setIsOpenListCard={setIsOpenListCard} isLoader={isLoader} />

                {dataStatus ? <>
                    <Card stretch data-tour='list'>
                        <CardHeader borderSize={1}>
                            <CardLabel icon='List' iconColor='info' className="col-lg-7">
                                <CardTitle tag='div' className='h5'>Weight List</CardTitle>
                            </CardLabel>
                            <CardActions>
                                {productList != '' ?
                                    <Button
                                        color='primary'
                                        isLight
                                        icon='Print'
                                        onClick={() => {
                                            selectPrint();
                                        }}>
                                        Print
                                    </Button>
                                    : null
                                }
                            </CardActions>
                        </CardHeader>
                        <CardBody>
                            {productList != '' ?
                                <div className='p-4' id="print-container" ref={componentRef}>
                                    <style dangerouslySetInnerHTML={{
                                        __html: `
                                        @media print {
                                            @page {
                                                margin: 5mm;
                                            }
                                            .print-compact-table {
                                                width: 100% !important;
                                                border-collapse: collapse !important;
                                            }
                                            .print-compact-table th, 
                                            .print-compact-table td {
                                                padding: 3px 3px !important;
                                                font-size: 11px !important;
                                                line-height: 1 !important;
                                                height: auto !important;
                                            }
                                            .print-compact-table h5 {
                                                font-size: 14px !important;
                                                margin: 5px 0 !important;
                                            }
                                            .print-compact-table b {
                                                font-size: 10px !important;
                                            }
                                            #print-container {
                                                overflow: visible !important;
                                                height: auto !important;
                                            }
                                        }
                                    `}} />
                                    {productList.map((item: any, index: number) => {
                                        const displayPackingList = isPrintShow ? item.packingList.filter((p: any) => p.packingDescription && p.packingDate && p.packingCount) : item.packingList;
                                        return (
                                            <div key={index} style={{ pageBreakInside: 'avoid', breakInside: 'avoid' }} className='mb-5'>
                                                <table className="table table-responsive table-bordered border border-dark border-1 print-compact-table small" style={{ fontSize: '12px' }}>
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '40%' }} colSpan={5} className="align-middle p-2">
                                                                <div className="text-start ps-2">
                                                                    <div className="fw-bold text-dark text-uppercase" style={{ fontSize: '12.5px', letterSpacing: '0.5px' }}>
                                                                        {item.companyName}
                                                                    </div>
                                                                    <div className="text-muted fw-semibold mt-1" style={{ fontSize: '9.5px' }}>
                                                                        {item.cityName} &bull; Yarn Weight List
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="align-middle p-2" style={{ width: '30%' }} colSpan={4}>
                                                                <div className="text-start ps-3" style={{ fontSize: '11px', lineHeight: '1.4' }}>
                                                                    <div><b>Date :</b> <span className="fw-bold">{item.dispatchDateForView}</span></div>
                                                                    {item.deliveryLocation && String(item.deliveryLocation).trim() !== '' && (
                                                                        <div className="mt-1"><b>Delivery Location :</b> <span className="fw-bold">{String(item.deliveryLocation)}</span></div>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className="align-middle p-2" style={{ width: '30%' }} colSpan={3}>
                                                                <div className="pe-2 text-end" style={{ fontSize: '11px', lineHeight: '1.4' }}>
                                                                    <div><b><u>Truck No</u></b></div>
                                                                    <div className="fw-bold text-dark text-uppercase mt-1" style={{ fontSize: '12px', letterSpacing: '0.3px' }}>
                                                                        {item.truckNo || '-'}
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ lineHeight: '0.1', width: '50%' }} colSpan={12}>
                                                                <div className="text-center font-semibold border-b border-black py-1 fw-bold mt-1" style={{ fontSize: '11px' }}>
                                                                    {(item.duplicateFlag === true || item.duplicateFlag == 1) && (
                                                                        <Icon icon='Warning' color='dark' className="me-1 align-middle" style={{ verticalAlign: 'middle' }} />
                                                                    )}
                                                                    {item.countNo} [ Lot No : &nbsp;{item.lotNo} ] [ No of Cone :&nbsp;{item.noOfCone} ] [ Cone Weight :&nbsp; {item.coneWeight} ]
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        <tr className='text-center'>
                                                            <td className='' style={{ width: '5%' }}>S.No</td>
                                                            <td className='border border-dark' style={{ width: '10%' }}>Bag No</td>
                                                            <td className='border border-dark' style={{ width: '8%' }}>Excise No</td>
                                                            <td className='border border-dark' style={{ width: '8%' }}>Tare Wt</td>
                                                            <td className='border border-dark' style={{ width: '10%' }}>Bag Wt</td>
                                                            <td className='border border-dark' style={{ width: '10%' }}>Gross Wt</td>

                                                            <td className='' style={{ width: '6%' }}>S.No</td>
                                                            <td className='border border-dark' style={{ width: '10%' }}>Bag No</td>
                                                            <td className='border border-dark' style={{ width: '8%' }}>Excise No</td>
                                                            <td className='border border-dark' style={{ width: '8%' }}>Tare Wt</td>
                                                            <td className='' style={{ width: '10%' }}>Bag Wt</td>
                                                            <td className='border border-dark' style={{ width: '10%' }}>Gross Wt</td>
                                                        </tr>

                                                        {item.leftRows.map((leftRow: any, i: any) => {
                                                            const rightRow = item.rightRows[i];  // match right row by index

                                                            return (
                                                                <tr className='text-center' key={i}>
                                                                    {/* LEFT SIDE */}
                                                                    <td className="p-1 ">{leftRow.sno}</td>
                                                                    <td className="border border-dark p-1">{leftRow.bagNo}</td>
                                                                    <td className="border border-dark p-1">{leftRow.exciseNo}</td>
                                                                    <td className="border border-dark p-1">{leftRow.grossWeight}</td>
                                                                    <td className="border border-dark p-1">{leftRow.tareWeight}</td>
                                                                    <td className="border border-dark p-1">{leftRow.netWeight}</td>

                                                                    {/* RIGHT SIDE */}
                                                                    {rightRow ? (
                                                                        <>
                                                                            <td className="p-1">{rightRow.sno}</td>
                                                                            <td className="border border-dark p-1">{rightRow.bagNo}</td>
                                                                            <td className="border border-dark p-1">{rightRow.exciseNo}</td>
                                                                            <td className="border border-dark p-1">{rightRow.grossWeight}</td>
                                                                            <td className="border border-dark p-1">{rightRow.tareWeight}</td>
                                                                            <td className="p-1">{rightRow.netWeight}</td>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                            <td></td><td></td><td></td><td></td><td></td><td></td>
                                                                        </>
                                                                    )}
                                                                </tr>

                                                            );
                                                        })}
                                                        <tr className='text-center'>
                                                            <td className="p-1 fw-bold" colSpan={3}>Total</td>
                                                            <td className="border border-dark p-1">{item?.leftTotals?.gross.toFixed(3)}</td>
                                                            <td className="border border-dark p-1">{item?.leftTotals?.tare.toFixed(3)}</td>
                                                            <td className="border border-dark p-1">{item?.leftTotals?.net.toFixed(3)}</td>
                                                            <td className="border border-dark p-1 fw-bold" colSpan={3}>Total</td>
                                                            <td className="border border-dark p-1">{item?.rightTotals?.gross.toFixed(3)}</td>
                                                            <td className="border border-dark p-1">{item?.rightTotals?.tare.toFixed(3)}</td>
                                                            <td className="p-1">{item?.rightTotals?.net.toFixed(2)}</td>
                                                        </tr>

                                                        <tr>
                                                            <td className="text-center fw-bold align-middle">S.No</td>
                                                            <td className="text-center fw-bold align-middle" colSpan={3}>Count No</td>
                                                            <td className="text-center fw-bold align-middle" colSpan={2}>Bag Range</td>
                                                            <td className="text-center fw-bold align-middle" colSpan={1}>Bags</td>
                                                            <td className="text-center fw-bold align-middle" colSpan={2}>Gross Wt</td>
                                                            <td className="text-center fw-bold align-middle" colSpan={1}>Tare Wt</td>
                                                            <td className="text-center fw-bold align-middle" colSpan={2}>Bag Wt</td>
                                                        </tr>
                                                        <tr>
                                                            <td className="text-center align-middle">1</td>
                                                            <td className="text-center align-middle" colSpan={3}>
                                                                {(item.duplicateFlag === true || item.duplicateFlag == 1) && (
                                                                    <Icon icon='Warning' color='dark' className="me-1 align-middle" style={{ verticalAlign: 'middle' }} />
                                                                )}
                                                                {item.countNo}
                                                            </td>
                                                            <td className="text-center align-middle" colSpan={2}>{item.fromBagNo} - {item.toBagNo}</td>
                                                            <td className="text-center align-middle" colSpan={1}>{item.productList?.length}</td>
                                                            <td className="text-center align-middle" colSpan={2}>{item.totalGrossWeight.toFixed(3)}</td>
                                                            <td className="text-center align-middle" colSpan={1}>{item.totalTareWeight.toFixed(3)}</td>
                                                            <td className="text-center align-middle" colSpan={2}>{item.totalNetWeight.toFixed(3)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <table className="table border-0 w-100 mt-2 small">
                                                    <tbody>
                                                        <tr>
                                                            <td style={{ width: '25%' }} className="border-0"><span className='ms-2'>Incharge</span></td>
                                                            <td style={{ width: '25%' }} className="border-0">Che By</td>
                                                            <td style={{ width: '25%' }} className="border-0">Fm</td>
                                                            <td style={{ width: '25%' }} className="border-0">Gm</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        );
                                    })}
                                </div> : <div className="text-center fw-bold text-danger">{noDataMsg}</div>
                            }

                        </CardBody>
                    </Card></> : null
                }
            </Page>
        </PageWrapper >
    )
}

export default DispatchList